<template>
  <section class="bg-white shadow p-3 mb-4">
    <div class="d-flex align-items-center justify-content-between">
      <h2>Benutzer</h2>

      <RegisterUserModal />
    </div>

    <div class="row mx-0 mb-2">
      <div class="col">Benutzername</div>
      <div class="col-2">Erstellt am</div>
      <div class="col-2"></div>
    </div>

    <UserRow v-for="user in userStore.users" :key="user.id" :user="user" />
  </section>
</template>

<script lang="ts" setup>
  //#region Imports
  import { onMounted } from 'vue';
  import { useUserStore } from '@/stores/userStore';

  import UserRow from '@/components/Einstellungen/Users/UserRow.vue';
  import RegisterUserModal from '@/components/Einstellungen/Users/RegisterUserModal.vue';
  //#endregion

  const userStore = useUserStore();

  onMounted(() => {
    userStore.getAllUsers();
  });
</script>
